import { render, staticRenderFns } from "./PurchaseAborted.vue?vue&type=template&id=cb258a9c&lang=pug&"
import script from "./PurchaseAborted.vue?vue&type=script&lang=js&"
export * from "./PurchaseAborted.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAborted.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports